import React, { useState } from 'react';
import { useIdentityContext } from '@design-stack-vista/identity-provider';
import qs from 'qs';
import { BoundedContent, Box, Button, Link, Typography } from '@vp/swan';
import { LOCALIZED_ROUTES } from 'src/constants';

type BookletsQueryParamsType = {
  key: string;
  productVersion: number;
  selectedOptions: string;
  qty?: number;
  editUrl?: string;
  createdBy?: string;
};

const naBookletsQueryParams: BookletsQueryParamsType = {
  key: 'PRD-G6UZIHNM',
  productVersion: 13,
  selectedOptions: JSON.stringify({ Size: '5.5" x 8.5"', Pages: '12p (cover + 8 inside)' }),
  qty: 1,
};

const euBookletsQueryParams: BookletsQueryParamsType = {
  key: 'PRD-ESGJ2KYHR',
  productVersion: 28,
  selectedOptions: JSON.stringify({ Size: 'A5 Portrait', 'Page Count (Including cover)': '8' }),
  qty: 1,
};

const auBookletsQueryParams: BookletsQueryParamsType = {
  key: 'PRD-IXE5AFARM',
  productVersion: 9,
  selectedOptions: JSON.stringify({ Size: 'A5', 'Number of Pages': '8pp' }),
  qty: 1,
};

const euPerfectBookletsQueryParams: BookletsQueryParamsType = {
  key: 'PRD-ZJ6EMXNJY',
  productVersion: 8,
  selectedOptions: JSON.stringify({ Size: 'A4 Portrait', 'Page Count': '40' }),
  qty: 1,
};

const vistaCreatePostersQueryParams: BookletsQueryParamsType = {
  key: 'PRD-HSKBMXYA',
  productVersion: 32,
  selectedOptions: JSON.stringify({
    Lamination: 'No',
    'Product Orientation': 'Vertical',
    Size: '16" X 20"',
    Substrates: 'Semi-Gloss',
  }),
  qty: 1,
  editUrl: 'https://create.vista.com/team/projects/6233918a4aee996cedb42ad1/',
  createdBy: 'VistaCreate',
};

const naWireBoundBookletsQueryParams: BookletsQueryParamsType = {
  key: 'PRD-SDBNXQAVH',
  productVersion: 1,
  selectedOptions: JSON.stringify({
    Size: '5.5"+x+8.5',
    'Cover Stock': 'Premium Matte',
    'Inner Page Stock': 'Matte',
    'Page Count': '32',
    'Product Orientation': 'Portrait',
    'Binding Placement': 'Left Side',
  }),
  qty: 1,
};

function buildUrl(culture: string, queryParams: { [key: string]: unknown }) {
  const translatedUrls = LOCALIZED_ROUTES[culture.toLowerCase()];
  console.log(translatedUrls);
  const returnData = `${translatedUrls}?${qs.stringify({ ...queryParams, culture })}`;
  console.log(returnData);
  return returnData;
}

export const DevLandingPage: React.FC = () => {
  const [filePath, setFilePath] = useState('');
  const { auth: vpAuth } = useIdentityContext();

  return (
    <BoundedContent>
      <Typography component="h1" fontSize={'x2large'}>
        Design Services Upload and Print Page
      </Typography>
      {vpAuth &&
        (vpAuth.isSignedIn() ? (
          <Button size="mini" onClick={() => vpAuth.signOut()}>
            Sign out
          </Button>
        ) : (
          <Button size="mini" onClick={() => vpAuth.signIn()}>
            Sign in
          </Button>
        ))}
      <Box>
        <Link href={buildUrl('en-US', naBookletsQueryParams)}>en-US Saddle Stitch booklets</Link>
      </Box>
      <Box>
        <Link href={buildUrl('en-CA', naBookletsQueryParams)}>en-CA Saddle Stitch booklets</Link>
      </Box>
      <Box>
        <Link href={buildUrl('es-US', naBookletsQueryParams)}>es-US Saddle Stitch booklets</Link>
      </Box>
      <Box>
        <Link href={buildUrl('en-IE', euBookletsQueryParams)}>en-IE Stapled booklets</Link>
      </Box>
      <Box>
        <Link href={buildUrl('fr-FR', euBookletsQueryParams)}>fr-FR Stapled booklets</Link>
      </Box>
      <Box>
        <Link href={buildUrl('en-AU', auBookletsQueryParams)}>en-AU Stitched booklets</Link>
      </Box>
      <Box>
        <Link href={buildUrl('en-IE', euPerfectBookletsQueryParams)}>en-IE Perfect Bound booklets</Link>
      </Box>
      <Box>
        <Link href={buildUrl('en-US', naWireBoundBookletsQueryParams)}>en-US Wire O booklets</Link>
      </Box>
      <Box>
        <Link
          href={buildUrl('en-US', {
            ...vistaCreatePostersQueryParams,
            fileUri: filePath ? `https://create.vista.com${filePath}` : '',
          })}
        >
          VistaCreate en-US posters
        </Link>{' '}
        File path: <input value={filePath} onChange={e => setFilePath(e.target.value)} />
      </Box>
    </BoundedContent>
  );
};
